export const columns1 = [
  {
    title: '编号',
    dataIndex: 'id',
  },
  {
    title: '昵称',
    dataIndex: 'user_nickname',
  },
  {
    title: '真实姓名',
    dataIndex: 'user_realname',
  },
  {
    title: '手机号',
    dataIndex: 'mobile',
  },
  {
    title: '所在区域',
    dataIndex: 'name',
  },
  {
    title: '关联医生数量',
    dataIndex: 'doctor_count',
    scopedSlots: { customRender: 'doctor_count' },
  },
  // {
  //   title: '积分',
  //   dataIndex: 'score',
  // },
  {
    title: '状态',
    dataIndex: 'status',
    customRender: (text, record, index) => {
      return record.status === 0 ? '禁用' : '启用';
    },
  },
  {
    title: '操作',
    dataIndex: 'operation',
    scopedSlots: { customRender: 'operation' },
  },
];
export const columns2 = [
  {
    title: '编号',
    dataIndex: 'id',
  },
  {
    title: '昵称',
    dataIndex: 'user_nickname',
  },
  {
    title: '真实姓名',
    dataIndex: 'user_realname',
  },
  {
    title: '手机号',
    dataIndex: 'mobile',
  },
  // {
  //   title: '积分',
  //   dataIndex: 'score',
  // },
  {
    title: '状态',
    dataIndex: 'status',
    customRender: (text, record, index) => {
      return record.status === 0 ? '禁用' : '启用';
    },
  },
  {
    title: '添加时间',
    dataIndex: 'create_time',
  },
  {
    title: '操作',
    dataIndex: 'operation',
    scopedSlots: { customRender: 'operation' },
  },
];
export const columns3 = [
 {
   title: 'Excel行号',
   dataIndex: 'line',
  //  align:'center',
   width:'6%'
 },
  {
    title: '昵称',
    dataIndex: 'user_nickname',
	width:'8%'
  },
  {
    title: '代表姓名',
    dataIndex: 'user_realname',
	width:'10%'
  },
  {
    title: '代表性别',
    dataIndex: 'sex',
  	width:'10%'
  },
  {
    title: '手机号',
    dataIndex: 'mobile',
	width:'15%'
  },
  {
    title: '省份',
    dataIndex: 'province',
	width:'10%'
  },
  {
    title: '城市',
    dataIndex: 'city',
	width:'10%'
  },
  {
    title: '个人简介',
    dataIndex: 'introduction',
	width:'15%'
  },
  {
    title: '反馈信息',
    dataIndex: 'error_msg',
	scopedSlots: { customRender: 'error_msg' },
	width:'14%'
  },
];
export const formData = [
  {
    name: 'user_realname',
    lable: '真实姓名',
    lableCol: 4,
    wrapperCol: 18,
  },
  {
    name: 'user_nickname',
    lable: '昵称',
    lableCol: 4,
    wrapperCol: 18,
  },
  {
    name: 'sex',
    lable: '性别',
    lableCol: 4,
    wrapperCol: 18,
  },
  {
    name: 'address',
    lable: '地区',
    lableCol: 4,
    wrapperCol: 18,
  },
  {
    name: 'mobile',
    lable: '手机号',
    lableCol: 4,
    wrapperCol: 18,
  },
  {
    name: 'introduction',
    lable: '个人简介',
    lableCol: 4,
    wrapperCol: 18,
  },
];

export const allotBusinessColumns = [
  {
    name: 'user_realname',
    lable: '推广人姓名',
    lableCol: 4,
    wrapperCol: 18,
  },
  {
    name: 'allot_buesness',
    lable: '分配客户',
    lableCol: 4,
    wrapperCol: 18,
    class: 'allot_buesness'
  },
];